<script setup lang="ts">
import { Locales } from '@/store/language.interface';
import { getLabel } from '@/utils/data-display-utils';

import { QSpinnerTail } from 'quasar';

// PROPS
const props = defineProps<{
  languageEnabled?: Locales[];
}>();
</script>

<template>
  <div class="loading-page">
    <q-spinner-tail color="primary" size="4em" />
    <div class="loading-page__text">{{ getLabel('loading', props.languageEnabled) }}</div>
  </div>
</template>

<style lang="scss">
.loading-page {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &__text {
    font-size: $small-title;
  }
}

@media screen and (max-width: $breakpoint-sm) {
  .loading-page {
    .q-spinner {
      height: 3em;
      width: 3em;
    }
  }
}
</style>
